import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { Stack, Box, Typography, useTheme } from '@mui/material'

import { useItemsSelected } from '../store'
import useActions from './use-actions'
import ActionModal from 'components/Modal/ActionModal'
import ProgressBar from '../components/ProgressBar'
import { trackEvent } from 'analytics'

const DeleteInMass = ({onClose}) => {
  const {t} = useTranslation()
  const {roomId, siteId} = useParams()
  const navigate = useNavigate()
  const [itemsToDelete, setItemsToDelete] = useItemsSelected()
  const [count] = useState(itemsToDelete.length)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const apiActions = useActions()
  const itemsToProcess = useRef(null)
  const theme = useTheme()

  const handleRemove = async () => {
    setLoading(true)
    itemsToProcess.current = [...itemsToDelete]
    let isOnError = false
    let processedCount = 0
    while (itemsToProcess.current.length && !isOnError) {
      const item = itemsToProcess.current.shift()
      const {error: e} = await apiActions.delete({roomId: item.id})
      if (e) {
        isOnError = true
        setError(e)
      } else {
        processedCount += 1
        setItemsToDelete(prev => prev.filter(({id}) => id !== item.id))
      }
    }
    if (processedCount) {
      trackEvent('private_wifi_deleted', { action_scope: 'bulk', item_count: processedCount })
    }
    if (!isOnError && roomId) {
      navigate(`/ran/${siteId}`)
    }
    setLoading(false)
  }

  const handleClose = () => {
    itemsToProcess.current = []
    onClose()
  }
  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmLabel={t('ui_elements.remove')}
      description={loading
        ? (
          <Box
            sx={{
              fontSize: 14,
              textAlign: 'center'
            }}
            dangerouslySetInnerHTML={{ __html: t('ran.modal_reset.processing_detail') }}
          />
        )
        : (
          <Stack sx={{textAlign: 'center'}}>
            <Box component={'span'} sx={{fontSize: 14}}>
              {t('ran.modal_delete.detail_1')}
              <Box component={'span'} sx={{color: theme.palette.error.main, fontWeight: 500, margin: '4px'}}>
                {count}
              </Box>
              {t('ran.modal_delete.detail_2')}
              <br />
              {t('ran.modal_delete.detail_3')}
            </Box>
          </Stack>
        )}
      hideActions={loading}
      icon={<i className={`fa-regular fa-${loading ? 'hourglass' : 'trash'}`} />}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleRemove}
      title={loading ? t('ran.modal_delete.title_loading') : t('ran.modal_delete.title')}
    >
      {Boolean(error) && <Typography color={'error'}>{t('ran.actions.error')}</Typography>}
      {loading && (
        <>
          <ProgressBar variant={'error'} percent={((count - itemsToDelete.length) * 100) / count} />
          <Stack sx={{ fontSize: 10 }} alignItems={'center'}>
            <Stack direction={'row'} gap={1} sx={{ color: theme.palette.grey[500] }}>
              <Box sx={{ fontWeight: 600 }} color={'black'}>
                {count - itemsToDelete.length}
              </Box>
              {t('ran.modal_delete_counter.body', { count })}
            </Stack>
          </Stack>
        </>
      )}
    </ActionModal>
  )
}


export default DeleteInMass